var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompanyProfileForm',{attrs:{"companyProfile":_vm.company,"startingMenu":_vm.startingMenu}})
}
var staticRenderFns = []

export { render, staticRenderFns }